import WorkflowActionsController from 'cio/pods/base/setup/workflow/actions/controller';
export default WorkflowActionsController;
